import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API from '../api/axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      API.get('/auth/me')
        .then(res => setUser(res.data))
        .catch(() => { localStorage.removeItem('token'); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await API.post('/auth/login', { email, password });
    localStorage.setItem('token', res.data.token);
    // Fetch full user with module permissions
    const meRes = await API.get('/auth/me');
    setUser(meRes.data);
    return res.data;
  };

  const register = async (name, email, password, role) => {
    const res = await API.post('/auth/register', { name, email, password, role });
    localStorage.setItem('token', res.data.token);
    const meRes = await API.get('/auth/me');
    setUser(meRes.data);
    return res.data;
  };

  const logout = async () => {
    try { await API.post('/auth/logout'); } catch {}
    localStorage.removeItem('token');
    setUser(null);
  };

  /**
   * canAccess(moduleKey, action = 'view')
   * Returns true for admin users or when the role has the requested permission.
   */
  const canAccess = useCallback((moduleKey, action = 'view') => {
    if (!user) return false;
    if (user.role?.isAdmin) return true;
    const perms = user.role?.modulePermissions || [];
    const entry = perms.find(mp => mp.module?.key === moduleKey);
    return !!(entry?.permissions?.[action]);
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, canAccess }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
